import { render } from "./TermOfUsePopup.vue?vue&type=template&id=c9813ace"
import script from "./TermOfUsePopup.vue?vue&type=script&lang=js"
export * from "./TermOfUsePopup.vue?vue&type=script&lang=js"

import "./TermOfUsePopup.vue?vue&type=style&index=0&id=c9813ace&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__